var map = {
	"./assassination/details.vue": 271,
	"./investigation/details.vue": 273,
	"./policy/details.vue": 276,
	"./role-assignment/details.vue": 279,
	"./special-election/details.vue": 280,
	"./veto/details.vue": 283,
	"./vote/details.vue": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;


//////////////////
// WEBPACK FOOTER
// ./src.player/ui/events/events ([\w-]+)\/details.vue$
// module id = 364
// module chunks = 0